import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	icon: {
		id: 'issue-field-parent-readview-full.parent.icon',
		defaultMessage: '{issueType} icon',
		description: 'Alt text explainer for the parent issue type icon, i.e. Epic icon',
	},
	noValueTextExperiment: {
		id: 'issue-field-parent.no-value-text-experiment',
		defaultMessage: 'Add parent',
		description: 'Message when the field has no value',
	},
});
